import { useMemo } from 'react';
import { Account, Feature, getFeatureFromPlan, PlanInterval } from '../../../models';
import { PRODUCT_QUERY_PARAMS, TRACKING_QUERY_PARAMS } from '../../../utils/Constants';
import { useQuery } from '../../../routes';

type QueryParam = {
  [key: string]: any; // 👈️ variable key
};

export const useParseQueryParam = (selectedAccount?: Account): QueryParam => {
  const { get } = useQuery();
  const spEnabled = get('spEnabled') === 'true';
  const ftic = get('ftic') === 'true';
  const queryParam: QueryParam = {};

  if (spEnabled) {
    queryParam.sp = true;
  }

  if (ftic) {
    queryParam.ftic = true;
  }

  PRODUCT_QUERY_PARAMS.forEach(param => {
    const value = get(param);
    if (value) {
      const feature = getFeatureFromPlan(param);
      const prefix = Feature.getFeaturePrefix(feature);
      const interval = PlanInterval.getIntervalFromPlanCode(param);
      queryParam[`${prefix}Quota`] = value;
      queryParam[`${prefix}Cycle`] = interval;
    }
  });
  TRACKING_QUERY_PARAMS.forEach(param => {
    const value = get(param);
    if (value) {
      queryParam[param] = value;
    }
  });
  return useMemo(
    () => {
      queryParam.accountId = selectedAccount?.id;
      return queryParam;
    },
    [selectedAccount],
  );
};
